import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, vShow as _vShow, withDirectives as _withDirectives, vModelSelect as _vModelSelect, createCommentVNode as _createCommentVNode, vModelCheckbox as _vModelCheckbox, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/down-icon.png'

const _withId = /*#__PURE__*/_withScopeId("data-v-40ab00ec")

_pushScopeId("data-v-40ab00ec")
const _hoisted_1 = { class: "main-wrap-inner" }
const _hoisted_2 = {
  id: "scrollable-div",
  class: "sidebar-menus"
}
const _hoisted_3 = { class: "mw-right-inner" }
const _hoisted_4 = { class: "collection-switcher" }
const _hoisted_5 = { class: "sidemenu_switch" }
const _hoisted_6 = {
  id: "switch-app",
  class: "fa fa-angle-double-right"
}
const _hoisted_7 = {
  id: "switch-app",
  class: "fa fa-angle-double-left"
}
const _hoisted_8 = { class: "datatable-header" }
const _hoisted_9 = { class: "datatable-sorting" }
const _hoisted_10 = { class: "total-view-box select-box" }
const _hoisted_11 = /*#__PURE__*/_createVNode("img", {
  class: "down-arrow-img",
  src: _imports_0,
  alt: ""
}, null, -1)
const _hoisted_12 = /*#__PURE__*/_createVNode("div", { class: "new-border" }, null, -1)
const _hoisted_13 = { class: "row" }
const _hoisted_14 = { key: 0 }
const _hoisted_15 = { key: 1 }
const _hoisted_16 = { key: 0 }
const _hoisted_17 = { key: 1 }
const _hoisted_18 = { class: "col-4 col-md-3 item-toggle-section text-right" }
const _hoisted_19 = {
  key: 0,
  class: "header-switch"
}
const _hoisted_20 = /*#__PURE__*/_createVNode("span", { class: "header-switch-slider" }, null, -1)
const _hoisted_21 = /*#__PURE__*/_createVNode("i", { class: "fa fa-pencil" }, null, -1)
const _hoisted_22 = /*#__PURE__*/_createVNode("span", { class: "go_top" }, [
  /*#__PURE__*/_createVNode("svg", {
    class: "icon",
    width: "200",
    height: "200",
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    "data-v-042ca774": ""
  }, [
    /*#__PURE__*/_createVNode("path", {
      fill: "currentColor",
      d: "M104.704 685.248a64 64 0 0090.496 0l316.8-316.8 316.8 316.8a64 64 0 0090.496-90.496L557.248 232.704a64 64 0 00-90.496 0L104.704 594.752a64 64 0 000 90.496z"
    })
  ])
], -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_top_header = _resolveComponent("top-header")
  const _component_details_header = _resolveComponent("details-header")
  const _component_list_container = _resolveComponent("list-container")
  const _component_chart_container = _resolveComponent("chart-container")
  const _component_table_container = _resolveComponent("table-container")
  const _component_report_container = _resolveComponent("report-container")
  const _component_preview_handler = _resolveComponent("preview-handler")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode(_component_top_header),
    _createVNode(_component_details_header, {
      title: _ctx.title,
      subTitle: _ctx.subTitle,
      searchFormName: _ctx.searchFormName
    }, null, 8, ["title", "subTitle", "searchFormName"]),
    _createVNode("section", {
      id: "details-page",
      class: {'header-fixed': _ctx.stickHeader}
    }, [
      _createVNode("div", _hoisted_1, [
        _createVNode("div", {
          class: ["mw-left", [!_ctx.canShowSideMenu ? 'hide' : 'show']]
        }, [
          _createVNode("div", _hoisted_2, [
            _createVNode("ul", {
              class: ["main-menu navigation", {'margin-fix-nav': _ctx.stickHeader}]
            }, [
              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.containers, (menu, index) => {
                return (_openBlock(), _createBlock("li", {
                  key: index,
                  onClick: ($event: any) => (_ctx.scrollToElement(index)),
                  class: { 'sub-menu': menu.isComposite },
                  id: 'menu-item-' + index
                }, [
                  _createVNode("a", {
                    class: { 'active-section-menu': _ctx.activeMenuIndex == index }
                  }, _toDisplayString(menu.title), 3)
                ], 10, ["onClick", "id"]))
              }), 128))
            ], 2)
          ])
        ], 2),
        _createVNode("div", {
          class: ["mw-right", [!_ctx.canShowSideMenu ? 'full-width' : '']]
        }, [
          _createVNode("div", _hoisted_3, [
            _createVNode("div", _hoisted_4, [
              _createVNode("div", {
                class: "header-menu",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.toggleSideMenu()))
              }, [
                _createVNode("span", _hoisted_5, [
                  _withDirectives(_createVNode("i", _hoisted_6, null, 512), [
                    [_vShow, !_ctx.canShowSideMenu]
                  ]),
                  _withDirectives(_createVNode("i", _hoisted_7, null, 512), [
                    [_vShow, _ctx.canShowSideMenu]
                  ])
                ])
              ]),
              _createVNode("div", _hoisted_8, [
                _createVNode("div", _hoisted_9, [
                  _createVNode("div", _hoisted_10, [
                    _hoisted_11,
                    _withDirectives(_createVNode("select", {
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.collectionIndex = $event)),
                      onChange: _cache[3] || (_cache[3] = ($event: any) => (_ctx.switchCollection(_ctx.collectionIndex)))
                    }, [
                      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.collections, (item, index) => {
                        return (_openBlock(), _createBlock("option", {
                          key: index,
                          value: index,
                          disabled: item.containers.length ? false : true
                        }, _toDisplayString(item.name), 9, ["value", "disabled"]))
                      }), 128))
                    ], 544), [
                      [_vModelSelect, _ctx.collectionIndex]
                    ])
                  ])
                ])
              ])
            ]),
            _hoisted_12,
            _withDirectives(_createVNode("div", { class: "no-data-center" }, _toDisplayString(_ctx.$t("default.alert.no_data")), 513), [
              [_vShow, !_ctx.containers?.length]
            ]),
            (_ctx.isDataFetched)
              ? (_openBlock(true), _createBlock(_Fragment, { key: 0 }, _renderList(_ctx.containers, (items, index) => {
                  return (_openBlock(), _createBlock("div", {
                    key: index,
                    class: ["container-wrap", !_ctx.isType(items, _ctx.ContainerType.COMPOSITE) ? items.width: ''],
                    index: index
                  }, [
                    _createVNode("div", _hoisted_13, [
                      _createVNode("div", {
                        class: ["col-8 col-md-9 item-title-section", { 'disable-box': !items.visible }]
                      }, [
                        (_ctx.isType(items, _ctx.ContainerType.COMPOSITE))
                          ? (_openBlock(), _createBlock("div", {
                              key: 0,
                              id: 'container' + index
                            }, [
                              (items.title)
                                ? (_openBlock(), _createBlock("h1", _hoisted_14, _toDisplayString(items.title), 1))
                                : _createCommentVNode("", true),
                              (items.sub_title)
                                ? (_openBlock(), _createBlock("h5", _hoisted_15, _toDisplayString(items.sub_title), 1))
                                : _createCommentVNode("", true)
                            ], 8, ["id"]))
                          : (_openBlock(), _createBlock("div", {
                              key: 1,
                              class: "heading",
                              id: 'container' + index
                            }, [
                              (items.title)
                                ? (_openBlock(), _createBlock("h2", _hoisted_16, _toDisplayString(items.title), 1))
                                : _createCommentVNode("", true),
                              (items.sub_title)
                                ? (_openBlock(), _createBlock("h5", _hoisted_17, _toDisplayString(items.sub_title), 1))
                                : _createCommentVNode("", true)
                            ], 8, ["id"]))
                      ], 2),
                      _createVNode("div", _hoisted_18, [
                        (_ctx.showHideToggleButton)
                          ? (_openBlock(), _createBlock("label", _hoisted_19, [
                              _withDirectives(_createVNode("input", {
                                type: "checkbox",
                                "onUpdate:modelValue": ($event: any) => (items.visible = $event),
                                onChange: ($event: any) => (_ctx.toggleSubContainers(items, index))
                              }, null, 40, ["onUpdate:modelValue", "onChange"]), [
                                [_vModelCheckbox, items.visible]
                              ]),
                              _createVNode("p", null, _toDisplayString(_ctx.$t("default.button.hide")), 1),
                              _hoisted_20
                            ]))
                          : _createCommentVNode("", true),
                        (items.edit_url)
                          ? (_openBlock(), _createBlock("span", {
                              key: 1,
                              onClick: ($event: any) => (_ctx.openContainerEditPage(items.edit_url)),
                              class: "edit_container"
                            }, [
                              _hoisted_21
                            ], 8, ["onClick"]))
                          : _createCommentVNode("", true)
                      ])
                    ]),
                    (_ctx.isType(items, _ctx.ContainerType.LIST) && items.visible)
                      ? (_openBlock(), _createBlock(_component_list_container, {
                          key: 0,
                          container: items
                        }, null, 8, ["container"]))
                      : _createCommentVNode("", true),
                    (_ctx.isType(items, _ctx.ContainerType.CHART) && items.visible)
                      ? (_openBlock(), _createBlock(_component_chart_container, {
                          key: 1,
                          container: items,
                          id: index,
                          index: index
                        }, null, 8, ["container", "id", "index"]))
                      : _createCommentVNode("", true),
                    (_ctx.isType(items, _ctx.ContainerType.TABLE) && items.visible)
                      ? (_openBlock(), _createBlock(_component_table_container, {
                          key: 2,
                          container: items,
                          onOnTableDataRefreshRequested: _cache[4] || (_cache[4] = ($event: any) => (_ctx.getDataToDisplay(true)))
                        }, null, 8, ["container"]))
                      : _createCommentVNode("", true),
                    (_ctx.isType(items, _ctx.ContainerType.REPORT) && items.visible)
                      ? (_openBlock(), _createBlock(_component_report_container, {
                          key: 3,
                          container: items
                        }, null, 8, ["container"]))
                      : _createCommentVNode("", true)
                  ], 10, ["index"]))
                }), 128))
              : _createCommentVNode("", true)
          ])
        ], 2)
      ]),
      _createVNode("div", {
        class: ["back_to_top_btn", _ctx.scrollClassName],
        onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.scrollToTop && _ctx.scrollToTop(...args)))
      }, [
        _hoisted_22
      ], 2),
      _createVNode(_component_preview_handler)
    ], 2)
  ], 64))
})